import { navigate } from "gatsby";
import React, { useCallback, useEffect, useState } from "react";

import Image from "../../components/image";
import ArrowRight from "../../images/icons/arrow-right.inline.svg";
import FgasaLightSVG from "../../images/icons/FGASA-light.inline.svg";
import FgasaDarkSVG from "../../images/icons/FGASA.png";
import ImpactLightSVG from "../../images/icons/Impact-light.inline.svg";
import ImpactDarkSVG from "../../images/icons/Impact.png";
import PadiLightSVG from "../../images/icons/PADI-light.inline.svg";
import PadiDarkSVG from "../../images/icons/PADI.png";
import { Link } from "../../utils/customLink";
import { formatForException } from "./format/formatForException";

const stack = new Map();

const MobileMenu = ({
  isOpen,
  menuItems,
  site,
  phoneNumber,
  colorMode,
  secondarySiteUrl
}) => {
  const [currentList, setList] = useState([]);
  const [currentTitle, setTitle] = useState("");
  const [level, setLevel] = useState("0");

  const brochures = site?.siteMetadata?.brochures;
  const socialmedia = site?.siteMetadata?.social_media;
  const intlNumber = phoneNumber ?? "";
  const icons = {
    "impact-icon": (
      <>
        <Image
          imageAlt="Impact icon"
          image={""}
          imageClass="hidden w-6 mr-4 dark:block"
          sourceUrl={ImpactDarkSVG}
        />
        <ImpactLightSVG className="w-6 h-6 mr-4 block dark:hidden bg-white p-0.5 rounded-full" />
      </>
    ),
    "fgasa-icon": (
      <>
        <Image
          imageAlt="Fgasa icon"
          image={""}
          imageClass="hidden w-6 mr-4 dark:block"
          sourceUrl={FgasaDarkSVG}
        />
        <FgasaLightSVG className="w-6 h-6 mr-4 block dark:hidden bg-white p-0.5 rounded-full" />
      </>
    ),
    "padi-icon": (
      <>
        <Image
          imageAlt="Padi icon"
          image={""}
          imageClass="hidden w-6 mr-4 dark:block"
          sourceUrl={PadiDarkSVG}
        />
        <PadiLightSVG className="w-6 h-6 mr-4 block dark:hidden bg-white p-0.5 rounded-full" />
      </>
    )
  };

  const handleMenuLink = useCallback(
    (item, index) => (e) => {
      if (item !== -1) {
        const currentLevel = level + index;
        setTitle(item.node);
        setList(item.subMenu);
        setLevel(currentLevel);
        stack.set(currentLevel, { title: item.node, list: item.subMenu });
      } else {
        const prevLevel = level.slice(0, -1);
        setLevel(prevLevel);
        const list = stack.get(prevLevel).list;
        const title = stack.get(prevLevel).title;
        setList(list);
        setTitle(title);
      }
    },
    [level]
  );

  const handleLink = useCallback(
    (url) => () => {
      navigate(url);
    },
    []
  );

  useEffect(() => {
    const formattedMenu = formatForException(
      menuItems,
      site,
      socialmedia,
      brochures,
      intlNumber,
      secondarySiteUrl,
      colorMode
    );

    setList(formattedMenu);
    stack.set(level, { title: "", list: formattedMenu });

    return () => {
      setTitle("");
      setList([]);
    };
    // eslint-disable-next-line
  }, [menuItems, socialmedia, brochures, intlNumber]);

  return (
    <div
      className={`${
        isOpen
          ? "w-full z-10 bg-secondary-bg fixed -ml-6 flex justify-center h-full pb-40"
          : "h-0 hidden"
      }`}
    >
      <div className="relative w-full">
        <div className="w-full h-full overflow-y-scroll">
          <div className="flex justify-center w-full bg-yellow-standard dark:bg-black-light">
            {currentTitle && (
              <div
                className="flex items-center w-11/12"
                onClick={handleMenuLink(-1)}
              >
                <span>
                  {" "}
                  <ArrowRight className="rotate-180 stroke-white h-3 w-auto" />{" "}
                </span>
                <div className="flex items-center gap-x-2">
                  <div
                    className="p-5 font-semibold !text-white h5 uppercase "
                    dangerouslySetInnerHTML={{ __html: currentTitle }}
                  />

                  {/journeys/gi.test(currentTitle) && (
                    <div
                      className="py-1 px-4 font-normal bg-red-light dark:bg-green-standard text-white dark:text-gray-darkest text-sm"
                      dangerouslySetInnerHTML={{ __html: "NEW!" }}
                    />
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="w-11/12 pr-6 pb-6 mx-auto ">
            {currentList.map((item, index) => (
              <React.Fragment key={index}>
                {item?.type !== "component" && (
                  <>
                    {(item?.node?.toLowerCase() === "group programs" ||
                      item?.node?.toLowerCase() === "volunteer" ||
                      item?.node?.toLowerCase() === "professional courses") && (
                      <div className="w-full pb-3 pt-4 active-link">
                        <Link className="uppercase h5" to={item?.url ?? "#"}>
                          {item?.node?.toLowerCase() === "volunteer"
                            ? "Individual Programs"
                            : item?.node}
                        </Link>
                      </div>
                    )}
                    <div
                      className={`${
                        item?.node?.toLowerCase() === "group programs" ||
                        item?.node?.toLowerCase() === "professional courses"
                          ? "hidden"
                          : ""
                      } flex items-center justify-between w-full py-5 font-semibold border-b text-black-lighter dark:text-gray-generic border-border-light dark:border-gray-generic`}
                      onClick={
                        item?.type === "menu" && item?.subMenu?.length
                          ? handleMenuLink(item, index)
                          : handleLink(item?.url)
                      }
                    >
                      {item?.type === "link" ? (
                        <>
                          {icons[item.description] ?? ""}
                          <Link
                            className="mr-auto text-xs font-normal"
                            to={item?.url ?? "#"}
                          >
                            {item?.node}
                          </Link>
                        </>
                      ) : (
                        <div className="flex flex-col gap-1">
                          <div className="flex items-center gap-x-2">
                            <div
                              className={`${
                                !currentTitle
                                  ? "h5 font-semibold uppercase"
                                  : "text-base font-semibold text-black-lighter dark:text-white"
                              }`}
                              dangerouslySetInnerHTML={{
                                __html: item?.node || ""
                              }}
                            />
                            {item?.cssClasses?.includes("new-flag") && (
                              <div
                                className="py-1 px-2 font-normal bg-red-light dark:bg-green-standard text-white dark:text-gray-darkest text-xxs"
                                dangerouslySetInnerHTML={{ __html: "NEW!" }}
                              />
                            )}
                          </div>

                          {(item?.cssClasses?.includes("new-flag") ||
                            item?.cssClasses?.includes("show-desc")) &&
                            item?.description && (
                              <div
                                className="italic text-xxs font-normal text-gray-lighter dark:text-gray-darkest"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description
                                }}
                              />
                            )}
                        </div>
                      )}
                      {item?.subMenu?.length ? (
                        <ArrowRight className="stroke-black-lighter dark:stroke-white h-3 w-auto" />
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                )}
                {item?.type === "component" && (
                  <div
                    className="flex items-center justify-between w-full"
                    key={index}
                  >
                    <div className="w-full">{item?.node}</div>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
